
export const ROLE_MAP = {
    Other: -1,
    Seller: 1,
    Buyer: 2,
    BandS: 3,
    Renter: 5,
    Investor: 6,
    Agent: 7,
    Homeowner: 8,
    Landlord: 9
};

export const STEP_MAP_ADS = {
    'questionPreQualified': 'question1',
    'priceRange': 'question2',
    'homeOwnership': 'question3',
    'readiness': 'question4',
    'personalization': 'question5',
    'exploreOptions': 'question6',
}

export const getBuyerRequestionListNew = ({ $t, hasValidPhone = false } = {}) => {
    return [
        {
            key: 'question1',
            show: true,
            behavior: 'questionPreQualified',
            title: $t('adNewQuestionV2.title1'),
            subTitle: $t('adNewQuestionV2.q1'),
            showBackBtn: false,
            item: [
                {
                    label: $t('adNewQuestionV2.q1_a1'),
                    data: {
                        answer: "Yes, I'm pre-qualified",
                        question: 'Do you already have financing in place?',
                        behavior: "questionPreQualified",
                        extraData: { preQualified: 'Yes' }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q1_a2'),
                    data: {
                        answer: 'Not yet',
                        question: 'Do you already have financing in place?',
                        behavior: "questionPreQualified",
                        extraData: { preQualified: 'No' }
                    }
                }
            ]
        },
        {
            key: 'question2',
            show: true,
            behavior: 'priceRange',
            title: $t('adNewQuestionV2.title2'),
            subTitle: $t('adNewQuestionV2.q2'),
            showBackBtn: true,
            item: [
                {
                    label: $t('adNewQuestionV2.q2_a0'),
                    data: {
                        answer: 'Below $400k',
                        question: "This helps show homes that match what you're looking for",
                        behavior: "questionDescribeMyself",
                        extraData: { budgetRange: 'Below $400k' }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q2_a1'),
                    data: {
                        answer: '$400k - $600k',
                        question: "This helps show homes that match what you're looking for",
                        behavior: "questionDescribeMyself",
                        extraData: { budgetRange: '$400k - $600k' }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q2_a2'),
                    data: {
                        answer: '$600k - $900k',
                        question: "This helps show homes that match what you're looking for",
                        behavior: "questionDescribeMyself",
                        extraData: { budgetRange: '$600k - $900k' }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q2_a3'),
                    data: {
                        answer: '$900k - $1.5M',
                        question: "This helps show homes that match what you're looking for",
                        behavior: "questionDescribeMyself",
                        extraData: { budgetRange: '$900k - $1.5M' }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q2_a4'),
                    data: {
                        answer: '$1.5M+',
                        question: "This helps show homes that match what you're looking for",
                        behavior: "questionDescribeMyself",
                        extraData: { budgetRange: '$1.5M+' }
                    }
                },
            ]
        },
        {
            key: 'question3',
            show: true,
            behavior: 'homeOwnership',
            title: $t('adNewQuestionV2.title3'),
            subTitle: $t('adNewQuestionV2.q3'),
            showBackBtn: true,
            item: [
                {
                    label: $t('adNewQuestionV2.q3_a1'),
                    showHomePage: true,
                    data: {
                        answer: "Yes, I own a home",
                        question: "Do you currently own a home?",
                        behavior: "questionSellingBuyNew",
                        extraData: {
                            isHomeowner: true,
                            homeAddress: ''
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q3_a2'),
                    data: {
                        answer: "No, I don't",
                        question: "Do you currently own a home?",
                        behavior: "questionSellingBuyNew",
                        extraData: {
                            isHomeowner: false,
                            homeAddress: ''
                        }
                    }
                },
            ]
        },
        {
            key: 'question4',
            show: true,
            behavior: 'readiness',
            title: $t('adNewQuestionV2.title4'),
            subTitle: $t('adNewQuestionV2.q4'),
            showBackBtn: true,
            item: [
                {
                    label: $t('adNewQuestionV2.q4_a1'),
                    data: {
                        answer: 'Ready to tour now',
                        question: "When are you hoping to move?",
                        behavior: "questionWantBuyingTime",
                        extraData: {
                            timeFrame: '0-1'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q4_a2'),
                    data: {
                        answer: 'In the next 1-3 months',
                        question: "When are you hoping to move?",
                        behavior: "questionWantBuyingTime",
                        extraData: {
                            timeFrame: '1-3'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q4_a3'),
                    data: {
                        answer: 'Buying in 3-6 months',
                        question: "When are you hoping to move?",
                        behavior: "questionWantBuyingTime",
                        extraData: {
                            timeFrame: '3-6'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q4_a4'),
                    data: {
                        answer: 'Buying in 6-12 months',
                        question: "When are you hoping to move?",
                        behavior: "questionWantBuyingTime",
                        extraData: {
                            timeFrame: '6-12'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q4_a5'),
                    data: {
                        answer: 'Buying in 12+ months',
                        question: "When are you hoping to move?",
                        behavior: "questionWantBuyingTime",
                        extraData: {
                            timeFrame: '12+'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q4_a6'),
                    data: {
                        answer: 'Just browsing for now',
                        question: "When are you hoping to move?",
                        behavior: "questionWantBuyingTime",
                        extraData: {
                            timeFrame: 'Just Looking'
                        }
                    }
                }

            ]
        },
        {
            key: 'question5',
            show: !hasValidPhone,
            behavior: 'personalization',
            title: $t('adNewQuestionV2.q5'),
            subTitle: '',
            showBackBtn: true,
            item: [
                {
                    label: $t('adNewQuestionV2.q5_a1'),
                    data: {
                        answer: 'Strong value and off-market opportunities',
                        question: "What should we prioritize for you?",
                        behavior: "questionDescribeMyself",
                        extraData: {
                            preference: 'Strong value and off-market opportunities'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q5_a2'),
                    data: {
                        answer: 'Beautiful homes in sought-after communities',
                        question: "What should we prioritize for you?",
                        behavior: "questionPersonalization",
                        extraData: {
                            preference: 'Beautiful homes in sought-after communities'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q5_a3'),
                    data: {
                        answer: 'Top-rated school districts and safe neighborhoods',
                        question: "What should we prioritize for you?",
                        behavior: "questionDescribeMyself",
                        extraData: {
                            preference: 'Top-rated school districts and safe neighborhoods'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q5_a4'),
                    data: {
                        answer: 'Deep local insights and neighborhood reports',
                        question: "What should we prioritize for you?",
                        behavior: "questionDescribeMyself",
                        extraData: {
                            preference: 'Deep local insights and neighborhood reports'
                        }
                    }
                }
            ]
        },
        {
            key: 'question6',
            show: true,
            behavior: 'exploreOptions',
            title: $t('adNewQuestionV2.q6'),
            subTitle: '',
            showBackBtn: true,
            item: [
                {
                    label: $t('adNewQuestionV2.q6_a1'),
                    showScheduleTourAds: true,
                    data: {
                        answer: 'Schedule a Private Tour',
                        question: "Explore your options",
                        behavior: "questionThanksInformation",
                        extraData: {
                            option: 'Schedule a Private Tour'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q6_a2'),
                    openPhonePopup: true,
                    data: {
                        answer: 'Learn your options with an expert Free consultation call',
                        question: "Explore your options",
                        behavior: "questionThanksInformation",
                        extraData: {
                            option: 'Learn your options with an expert Free consultation call'
                        }
                    }
                },
                {
                    label: $t('adNewQuestionV2.q6_a3'),
                    data: {
                        answer: 'Continue Browsing',
                        question: "Explore your options",
                        behavior: "questionThanksInformation",
                        extraData: {
                            option: 'Continue Browsing'
                        }
                    }
                }
            ]
        }
    ];
};

export const getBuyerRequestionList = isOwnerHouse => {
    return [
        {
            key: 'question1',
            show: isOwnerHouse,
            behavior: 'questionWantChangeOneHouse',
            item: [
                {
                    icon: 'icon-house_15',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question1'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/leadType',
                        type: 'post',
                        data: {
                            leadTypeList: ['Seller', 'Buyer'],
                            behavior: 'questionWantChangeOneHouse',
                        }
                    }
                },
                {
                    icon: 'icon-house_17',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question2'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/leadType',
                        type: 'post',
                        data: {
                            leadTypeList: ['Buyer'],
                            behavior: 'questionWantChangeOneHouse',
                        }
                    }
                }
            ]
        },
        {
            key: 'question2',
            show: true,
            behavior: 'questionWantBuyingTime',
            item: [
                {
                    icon: 'icon-calendar_01',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question3'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            timeFrame: '1-3'
                        }
                    }
                },
                {
                    icon: 'icon-view',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question4'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            timeFrame: 'Just Looking'
                        }
                    }
                }
            ]
        },
        {
            key: 'question3',
            show: true,
            behavior: 'questionPreQualified',
            item: [
                {
                    icon: 'icon-pre-approval',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question5'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            preQualified: 'YES'
                        }
                    }
                },
                {
                    icon: 'icon-pre-approval_02',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question6'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            preQualified: 'NO'
                        }
                    }
                }
            ]
        }
    ].filter(item => item.show);
};

export const getSellerRequestionList = isBuyerHouse => {
    return [
        {
            key: 'question1',
            show: true,
            behavior: 'questionSellingBuyNew',
            item: [
                {
                    icon: 'icon-like',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question9'),
                    note: {
                        desc: 'Lead has improved the personal info: lead also wants to buy a house'
                    },
                    type: 'buyer',
                    ajax: {
                        url: '/api-site/questionnaire/sync/leadType',
                        type: 'post',
                        data: {
                            leadTypeList: ['Seller', 'Buyer'],
                            behavior: 'questionSellingBuyNew',
                            extraData: 'buyer',
                        }
                    }
                },
                {
                    icon: 'icon-dislike',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question10'),
                    note: {
                        desc: 'Lead has improved the personal info: lead currently renting a house.'
                    },
                    type: 'renter',
                    ajax: {
                        url: '/api-site/questionnaire/sync/leadType',
                        type: 'post',
                        data: {
                            leadTypeList: ['Seller', 'Renter'],
                            behavior: 'questionSellingBuyNew',
                            extraData: 'renter',
                        }
                    }
                }
            ]
        },
        {
            key: 'question2',
            show: isBuyerHouse,
            behavior: 'questionWantBuyingTime',
            item: [
                {
                    icon: 'icon-calendar_01',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question3'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            timeFrame: '1-3'
                        }
                    }
                },
                {
                    icon: 'icon-view',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question4'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            timeFrame: 'Just Looking'
                        }
                    }
                }
            ]
        },
        {
            key: 'question3',
            show: true,
            behavior: 'questionPreQualified',
            item: [
                {
                    icon: 'icon-like',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question7'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            preQualified: 'YES'
                        }
                    }
                },
                {
                    icon: 'icon-dislike',
                    label: window.siteGlobalization.$t('common:adNewQuestion.question8'),
                    ajax: {
                        url: '/api-site/questionnaire/sync/phoneAddon/questionnaire',
                        type: 'post',
                        data: {
                            preQualified: 'NO'
                        }
                    }
                }
            ]
        }
    ].filter(item => item.show);
};
